import type { ExchangeRate } from './types';

// Enhanced mock data with realistic current parallel market rates (always lower than CBN)
const baseParallelRates: Omit<ExchangeRate, 'timestamp' | 'change'>[] = [
  {
    fromCurrency: 'USD',
    toCurrency: 'NGN',
    rate: 1340.35, // Current parallel market rate (Feb 2026) - lower than CBN
    symbol: '$'
  },
  {
    fromCurrency: 'EUR',
    toCurrency: 'NGN',
    rate: 1478.00, // Current parallel market rate - lower than CBN
    symbol: '€'
  },
  {
    fromCurrency: 'GBP',
    toCurrency: 'NGN',
    rate: 1715.00, // Current parallel market rate - lower than CBN
    symbol: '£'
  },
  {
    fromCurrency: 'CAD',
    toCurrency: 'NGN',
    rate: 990.00, // Current parallel market rate - lower than CBN
    symbol: 'C$'
  },
  {
    fromCurrency: 'AUD',
    toCurrency: 'NGN',
    rate: 893.00, // Current parallel market rate - lower than CBN
    symbol: 'A$'
  },
  {
    fromCurrency: 'XOF',
    toCurrency: 'NGN',
    rate: 2.19, // Current parallel market rate - lower than CBN
    symbol: 'CFA'
  }
];

// Generate live-like parallel market data with realistic variations
export function generateLiveMockRates(): ExchangeRate[] {
  return baseParallelRates.map(baseRate => {
    // Add realistic market variation (±0.5%)
    const variation = (Math.random() - 0.5) * 0.01; // ±0.5% max for realistic daily movement
    const newRate = baseRate.rate * (1 + variation);

    // Calculate realistic change percentage
    const change = variation * 100;

    return {
      ...baseRate,
      rate: Number(newRate.toFixed(4)),
      change: Number(change.toFixed(3)),
      timestamp: new Date()
    };
  });
}

// Static fallback rates (parallel market rates)
export const mockRates: ExchangeRate[] = baseParallelRates.map(baseRate => ({
  ...baseRate,
  change: (Math.random() - 0.5) * 3, // Random change between -1.5% and +1.5%
  timestamp: new Date()
}));